import { PlateType } from "./PlateType";

export enum EPlateErrorStatus {
  OK = 0,
  UnknownPlate = 1,
  DuplicateBarcode = 2,
  OverQuota = 4,
  //NotEnoughSlot = 8,
  NoChamberTemperature = 16,
  RetrieveFailed = 32,
  StoreFailed = 64,
  PlateDropped = 128,
  HardwareFailure = 256,
  WrongHotelType = 512,
  Missing = 1024,

  Querying = 2048
}

export enum EPlateImagingStatus {
  Idle = 0,
  Overview = 1,
  Imaging = 2,
}

export interface CanMovePlate {
  moduleIdentifier: string;
  canMove: boolean;
}

export interface Plate {
  id: number;
  plateId: string;
  plateType: PlateType;
  barcode: string;
  projectName: string;
  experimentName: string;
  setupTemp: number;
  incubationTemp: number;
  plateNumber: number;
  userName: string;
  userEmail: string;
  errorStatus: EPlateErrorStatus;
  imagingStatus: EPlateImagingStatus;
  isReferencePlate: boolean;
  isExpired: boolean;
  dateDispensed: string;
  isQueuedForTransfer: boolean;
  errorStatusMessages: string[];
}

export interface PlateTypeBackupEntry {
  id: number;
  name: string;
  date: string;
  note: string;
}
